/*!
 * PBS Wrapper — Flying carpet standalone
 *
 * Wrap a GPT/passback/postbid tag in a div. This script turns that div into
 * the aperture; the passback is the creative seen through windowHeight.
 *
 *   <div data-pbs-carpet
 *        data-ad-width="300"
 *        data-ad-height="600"
 *        data-window-height="250">
 *     <iframe id="postbid_iframe_carpet_1" width="300" height="600"></iframe>
 *     <script>pbjs.requestBids then renderAd into that iframe</script>
 *   </div>
 *   <script src="https://cdn.rediads.com/pbs-wrapper/formats/flying-carpet/flying-carpet-standalone.js"></script>
 *
 * Put the script after the div (or at the end of it). Do not wrap this in a
 * cross-origin SafeFrame — position:fixed must pin to the page.
 *
 * The chrome wraps the host div. It does not reparent the iframe — Chromium
 * reloads an iframe that changes parent, which wipes pbjs.renderAd.
 */
;(function () {
  'use strict'

  var STYLE_ID = 'pbs-carpet-standalone-css'
  var CSS =
    '[data-pbs-carpet]{display:block!important;width:100%!important;margin:28px 0!important}' +
    '[data-pbs-carpet] .pbs-carpet-mount{display:block!important;width:100%!important;' +
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif!important}' +
    '[data-pbs-carpet] .pbs-carpet-mount *{box-sizing:border-box!important}' +
    '[data-pbs-carpet] .pbs-carpet-panel{position:relative!important;display:block!important;width:100%!important}' +
    '[data-pbs-carpet] .pbs-carpet-label{display:flex!important;align-items:center!important;gap:8px!important;' +
    'margin:0!important;padding:5px 0!important;font:500 9.5px/1 inherit!important;' +
    'letter-spacing:.16em!important;text-transform:uppercase!important;color:#8b9099!important}' +
    '[data-pbs-carpet] .pbs-carpet-label::after{content:""!important;flex:1 1 auto!important;height:1px!important;' +
    'background:currentColor!important;opacity:.28!important}' +
    '[data-pbs-carpet] .pbs-carpet-window{position:relative!important;display:block!important;width:100%!important;' +
    'margin:0!important;padding:0!important;border:0!important;background:#f1f2f4!important}' +
    '[data-pbs-carpet] .pbs-carpet-clip{position:absolute!important;top:0!important;left:0!important;' +
    'width:100%!important;height:100%!important;border:0!important;margin:0!important;padding:0!important;' +
    'clip:rect(0,auto,auto,0)!important;clip-path:polygon(0 0,100% 0,100% 100%,0 100%)!important}' +
    '[data-pbs-carpet] .pbs-carpet-container{position:fixed!important;top:0!important;height:100%!important;' +
    'display:flex!important;flex-direction:column!important;align-items:center!important;' +
    'justify-content:center!important;margin:0!important;padding:0!important;' +
    '-webkit-transform:translateZ(0)!important;transform:translateZ(0)!important}' +
    '[data-pbs-carpet] .pbs-carpet-ad{display:block!important;margin:0!important;padding:0!important;' +
    'border:0!important;overflow:hidden!important}' +
    '[data-pbs-carpet] .pbs-carpet-ad iframe{display:block!important;width:100%!important;height:100%!important;' +
    'border:0!important;margin:0!important;padding:0!important}'

  function num(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10)
    return v > 0 ? v : fallback
  }

  function injectCss() {
    if (document.getElementById(STYLE_ID)) return
    var s = document.createElement('style')
    s.id = STYLE_ID
    s.textContent = CSS
    ;(document.head || document.documentElement).appendChild(s)
  }

  function unlockAncestors(start, levels) {
    var n = start
    var i
    for (i = 0; i < levels && n && n.nodeType === 1 && n.style; i++) {
      n.style.setProperty('height', 'auto', 'important')
      n.style.setProperty('max-height', 'none', 'important')
      n.style.setProperty('overflow', 'visible', 'important')
      n = n.parentElement
    }
  }

  function copyDataAttr(from, to, name) {
    if (from.hasAttribute(name)) to.setAttribute(name, from.getAttribute(name))
  }

  function boot(host) {
    if (!host || host.getAttribute('data-pbs-carpet-ready') === '1') return
    var parent = host.parentNode
    if (!parent) return
    host.setAttribute('data-pbs-carpet-ready', '1')

    var adW = num(host, 'data-ad-width', 300)
    var adH = num(host, 'data-ad-height', 250)
    var windowH = num(host, 'data-window-height', 250)

    injectCss()

    var wrap = document.createElement('div')
    wrap.setAttribute('data-pbs-carpet', host.getAttribute('data-pbs-carpet') || '')
    wrap.setAttribute('data-pbs-carpet-ready', '1')
    copyDataAttr(host, wrap, 'data-ad-width')
    copyDataAttr(host, wrap, 'data-ad-height')
    copyDataAttr(host, wrap, 'data-window-height')

    host.removeAttribute('data-pbs-carpet')
    host.className = (host.className ? host.className + ' ' : '') + 'pbs-carpet-ad'
    host.style.cssText =
      'width:' +
      adW +
      'px;height:' +
      adH +
      'px;max-width:100%;overflow:hidden;margin:0;padding:0;border:0;display:block'

    var mount = document.createElement('div')
    mount.className = 'pbs-carpet-mount'
    mount.innerHTML =
      '<div class="pbs-carpet-panel" role="complementary" aria-label="Advertisement">' +
      '<div class="pbs-carpet-label">Advertising</div>' +
      '<div class="pbs-carpet-window">' +
      '<div class="pbs-carpet-clip"><div class="pbs-carpet-container"></div></div>' +
      '</div>' +
      '<div class="pbs-carpet-label">Advertising</div>' +
      '</div>'

    var frame = mount.querySelector('.pbs-carpet-window')
    var container = mount.querySelector('.pbs-carpet-container')
    frame.style.height = windowH + 'px'

    parent.insertBefore(wrap, host)
    wrap.appendChild(mount)
    // Move the host div, not the iframe. Reparenting the iframe reloads it.
    container.appendChild(host)
    unlockAncestors(wrap.parentElement, 5)

    function syncWidth() {
      container.style.width = frame.getBoundingClientRect().width + 'px'
    }
    syncWidth()
    window.addEventListener('resize', syncWidth, { passive: true })
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-pbs-carpet]:not([data-pbs-carpet-ready])')
    var i
    for (i = 0; i < nodes.length; i++) boot(nodes[i])
  }

  var scriptEl = document.currentScript
  if (scriptEl && scriptEl.parentElement && scriptEl.parentElement.hasAttribute('data-pbs-carpet')) {
    boot(scriptEl.parentElement)
  }
  scan()
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan)
  }
})()
